<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-images</v-icon>
      <span class="title ml-2">Agregar imagen</span>
    </v-card-title>
    <v-img v-if="imagen" :src="imagen" height="300px"></v-img>
    <v-img v-else height="300px" class="grey"></v-img>
    <v-card-text>
      <v-file-input
        v-model="foto.imagen"
        label="Imagen"
        accept="image/*"
        :error-messages="errImagen"
        @change="fileChange()"
      ></v-file-input>
      <v-text-field
        v-model="foto.descripcion"
        label="Descripción"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-spacer />
      <v-btn color="primary" :loading="loading" @click="insertFoto()">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { fileSize } from '../plugins/vuelidate'
export default {
  data () {
    return {
      foto: {
        imagen: null,
        descripcion: ''
      },
      imagen: null,
      loading: false
    }
  },
  computed: {
    errImagen () {
      const errs = []
      if (!this.$v.foto.imagen.$dirty) return errs
      !this.$v.foto.imagen.required && errs.push('La imagen es requerida')
      !this.$v.foto.imagen.fileSize && errs.push('El tamaño maximo de la images es de 0.5MB')
      return errs
    }
  },
  methods: {
    fileChange () {
      if (this.foto.imagen) {
        this.imagen = URL.createObjectURL(this.foto.imagen)
      }
    },
    async insertFoto () {
      this.$v.foto.$touch()
      if (!this.$v.foto.$invalid) {
        try {
          this.loading = true
          const config = {
            headers: {
              'content-type': 'multipart/form-data'
            }
          }
          const formData = new FormData()
          formData.append('data', JSON.stringify({ descripcion: this.foto.descripcion }))
          formData.append('files.imagen', this.foto.imagen, this.imagen.name)
          await this.$http.fotos.post('/', formData, config)
          this.foto = {
            imagen: null,
            descripcion: ''
          }
          this.imagen = null
          this.$v.foto.$reset()
          this.$emit('saved')
          this.loading = false
        } catch (error) {
          this.loading = false
          window.alert('😓 Ha ocurrido un error al guardar la imagen')
        }
      }
    }
  },
  validations: {
    foto: {
      imagen: {
        required,
        fileSize: fileSize(512)
      }
    }
  }
}
</script>
